module.exports = __webpack_public_path__ + "static/media/addFile.84371f25.svg";